import { Utils } from '../Utils.js';
import { BodyBasedExpression } from './Expression.js';
export class OclIsTypeOfExpression extends BodyBasedExpression {
    evaluate(visitor, localVariables) {
        let source = this.getSource().evaluate(visitor, localVariables);
        source = Utils.getClassName(source);
        let body = this.getBody().evaluate(visitor, localVariables);
        if (typeof body !== 'string') {
            body = Utils.getClassName(body);
        }
        return source === body;
    }
}
//# sourceMappingURL=OclIsTypeOfExpression.js.map